import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {OrgGroupDto} from "../org-group.dto";

export class SearchOrgGroupRes extends SearchResultDto {

  public override readonly items: SearchOrgGroupItem[] = [];

  constructor(init?: Partial<SearchOrgGroupRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchOrgGroupItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchOrgGroupItem extends OrgGroupDto implements SearchItem {

  constructor(init?: Partial<SearchOrgGroupItem>) {
    super(init);
    Object.assign(this, init);
  }
}
